import { render, staticRenderFns } from "./edit2.vue?vue&type=template&id=4272f2fb&"
import script from "./edit2.vue?vue&type=script&lang=js&"
export * from "./edit2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports